import * as React from "react";
import { ModalConfirmation } from "@adsk/alloy-react-modal";
import { useTranslations } from "@adsk/acc-issues-translations";

export const PlacementDeleteModal = ({
  isOpen = false,
  onDelete,
  placementText,
  isFile,
  onClose,
}: {
  isOpen?: boolean;
  onDelete?: () => void;
  placementText?: string;
  isFile?: boolean;
  onClose: () => void;
}) => {
  const { T } = useTranslations();
  const modalMessage = isFile
    ? (T.translate("placementDeleteModal.fileMessage", {
        placementText,
      }) as string)
    : (T.translate("placementDeleteModal.sheetMessage", {
        placementText,
      }) as string);
  const modalTitle = isFile
    ? (T.translate("placementDeleteModal.fileTitle") as string)
    : (T.translate("placementDeleteModal.sheetTitle") as string);
  return (
    <ModalConfirmation
      style={{}}
      show={isOpen}
      onConfirm={onDelete}
      onClose={onClose}
      title={modalTitle}
      message={modalMessage}
      confirmationButtonLabel={T.translate("actions.remove") as string}
    />
  );
};
